import { Theme } from "@mui/material/styles";

export const sx = {

    root: (theme: Theme) => ({
        minHeight: "100vh",
        minWidth: "100vw",
        display: "flex",
        flexDirection: "column",
        // backgroundColor: theme.palette.background.default,
        color: theme.palette.text.primary,
    }),

    accentText: (theme: Theme) => ({
        color: theme.palette.primary.main,
    }),

    /* ─── HERO SECTION ────────────────────────────────────────────────────── */

    heroSection: (bg: string) => (theme: Theme) => ({
        width: "100%",
        // Let height breathe; don’t overconstrain
        minHeight: "40vh",
        height: "60vh",
        position: "relative",
        display: "flex",
        boxSizing: "border-box",

        backgroundImage: `url(${bg})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",

        [theme.breakpoints.down("md")]: {
            height: "50vh",
        },
        [theme.breakpoints.down("sm")]: {
            height: "auto",      // let content dictate height on tiny screens
            paddingBottom: theme.spacing(6),
        },
    }),

    /**
     * Wrapper for the text on the right side.
     */
    heroTextWrapper: (theme: Theme) => ({
        position: "relative",
        zIndex: 2,

        width: "40%",
        marginLeft: "auto",
        paddingRight: "5%",
        paddingLeft: "5%",
        justifyContent: "center",
        color: theme.palette.common.white,
        backgroundColor: `${theme.palette.secondary.main}61`,
        display: "flex",
        flexDirection: "column",
        gap: theme.spacing(2),

        [theme.breakpoints.down("md")]: {
            width: "60%",
            paddingRight: "4%",
        },

        [theme.breakpoints.down("sm")]: {
            width: "100%",
            paddingTop: theme.spacing(6),
            paddingRight: theme.spacing(3),
            paddingLeft: theme.spacing(3),
            // on very small screens, text just becomes a block over the image
            marginLeft: 0,
        },
    }),

    /* ─── TOOLS SECTION ────────────────────────────────────────────────────── */


    toolsInner: (theme: Theme) => ({
        width: "88%",
        maxWidth: "1200px",
        margin: "0 auto",
        boxSizing: "border-box",
    }),

    loaderRow: () => ({
        width: "100%",
        display: "flex",
        justifyContent: "center",
        paddingTop: "3%",
    }),

    errorText: (theme: Theme) => ({
        color: theme.palette.error.main,
        marginBottom: "1%",
    }),

    toolGrid: () => ({
        marginTop: "1%",
    }),

    toolCard: (theme: Theme, isReleased?: boolean) => ({
        width: "100%",
        height: "100%",
        display: "flex",
        flexDirection: "row" as const,
        justifyContent: "space-between",
        alignItems: "stretch",
        borderRadius: "23px",
        overflow: "hidden",
        boxSizing: "border-box",
        backgroundImage: `linear-gradient(
      0deg,
      ${theme.palette.secondary.main},
      ${theme.palette.primary.main}
    )`,
        color: theme.palette.getContrastText(theme.palette.primary.main),
        boxShadow: theme.shadows[6],

        transition: "box-shadow 0.3s ease, transform 0.2s ease",
        "&:hover": {
            boxShadow: `
        0 0 12px 3px ${theme.palette.primary.main}55,
        0 0 22px 6px ${theme.palette.primary.main}33
      `,
            cursor: "pointer",
        },

        [theme.breakpoints.down("sm")]: {
            flexDirection: "column" as const,
        },
        mixBlendMode: isReleased ? "normal" : "luminosity",
    }),

    toolCardContent: (theme: Theme) => ({
        width: "82%",
        display: "flex",
        flexDirection: "column",
        // justifyContent: "center",
        gap: theme.spacing(1.5),
        color: theme.palette.common.white,
        padding: theme.spacing(3),
        borderRadius: "23px",

        [theme.breakpoints.down("sm")]: {
            width: "100%",
            borderRadius: 0,
        },
    }),

    toolIcon: (theme: Theme) => ({
        // Responsive square size: never smaller than 40px, never bigger than 72px
        width: "clamp(80px, 12vw, 144px)",
        height: "clamp(80px, 12vw, 144px)",

        // Keep 1:1 box, don’t squish the icon
        aspectRatio: "1 / 1",
        objectFit: "contain",

        marginTop: "auto",
        marginRight: theme.spacing(1),
        marginBottom: "auto",
        marginLeft: theme.spacing(1),

        paddingTop: theme.spacing(1),
        paddingBottom: theme.spacing(1),

        // Prevent the icon from shrinking away in tight flex layouts
        flexShrink: 0,

        [theme.breakpoints.down("sm")]: {
            marginLeft: "auto",
            marginRight: "auto",
        }

    }),

    toolTitle: () => ({
        fontWeight: 600,
    }),

    toolBlurb: (theme: Theme) => ({
        fontSize: "0.9rem",
        lineHeight: 1.6,
        color: theme.palette.grey[100],
    }),

    toolSubscribeRail: (theme: Theme) => ({
        width: "15%",
        minWidth: "40px",
        height: "auto",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: theme.palette.primary.main,
        borderRadius: "23px",
        boxSizing: "border-box",

        [theme.breakpoints.down("sm")]: {
            width: "100%",
            height: "auto",
            borderRadius: 0,
            padding: theme.spacing(1),
        },
    }),


    toolSubscribeText: (theme: Theme) => ({
        writingMode: "vertical-rl",
        textOrientation: "mixed",
        textTransform: "uppercase",
        letterSpacing: "0.18em",
        fontSize: "0.9 rem",
        fontWeight: 700,
        color: theme.palette.common.white,
        [theme.breakpoints.down("sm")]: {
            writingMode: "horizontal-tb",
        },
    }),
};
